const borderRadios = {
    borderRadio: '18px',
    smallBorderRadio: '10px',
  };
  
  const spaces = {
    extraExtraSmallSpace: '4px',
    extraSmallSpace: '8px',
    smallSpace: '16px',
    normalSpace: '24px',
    extraNormalSpace: '32px',
    largeSpace: '40px',
    extraLargeSpace: '62px',
    hugeSpace: '100px',
  };
  
  const dimensions = {
    normalWidth: '190px',
    normalHeight: '36px',
    largeWidth: '108px',
  };
  
  const fontSizes = {
    ssm: '8px',
    xsm: '10px',
    sm: '12px',
    medium: '14px',
    normal: '16px',
    l: '18px',
    mxl: '22px',
    mlxl: '26px',
    xl: '27px',
    xxl: '30px',
    xxxl: '32px',
    xxxxl: '34px',
    xxxxxxl: '50px',
    xxxxxxxl: '75px',
  };
  
  export { borderRadios, spaces, dimensions, fontSizes };
  